// bookingscreen.js
import React, { useEffect, useState, useRef } from 'react';
import PopupComponent from './PopUp';
import { useNavigate } from 'react-router-dom';
import globalState from '../globalstate';
import { observer } from 'mobx-react-lite';
import { db, logFirebaseEvent } from '../firebase';
import ApiService from '../services/apiService';
import { LoadingProvider, useLoading } from './Loading';
import { collection, getDocs, doc, getDoc, query, where } from 'firebase/firestore';
import Topbar from './Topbar';
import Footer from './Footer';
import { usePopup } from './PopUp';

const BookingScreen = observer(() => {
    const navigate = useNavigate();
    const [isVerticalLayout, setIsVerticalLayout] = useState(window.innerWidth < (window.innerHeight*1.75));
  
    useEffect(() => {
      const handleResize = () => {
        setIsVerticalLayout(window.innerWidth < window.innerHeight*1.75);
      };
  
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, []);
  
    return (
      <LoadingProvider>
        <div style={{ position: 'relative' }}>
          
      <div style={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: 1000 }}>
        <Topbar />
      </div>
          <div
            style={{
              backgroundColor: '#f2f2f2',
              padding: isVerticalLayout ? '20px 12px':'20px 64px',
              minHeight: 'calc(100vh - 48px)',
              marginTop: '56px'
            }}
          >
            {/* <div style={{ marginBottom: '16px', alignItems: 'center', fontSize: '14px', color: '#333' }}>
              <button
                onClick={() => navigate('/adwav')}
                style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'black', fontWeight: 'bold' }}
              >
                Home
              </button>
              <span style={{ margin: '0 8px', color: 'black' }}> &gt; </span>
              <span style={{ fontWeight: 'bold' }}>Booking</span>
            </div> */}
  
            <div
              style={{
                display: 'flex',
                flexDirection: isVerticalLayout ? 'column' : 'row',
                gap: '24px',
              }}
            >
              <BookingSummary />
              <ContactInfoForm />
            </div>
          </div>
          <Footer />
        </div>
      </LoadingProvider>
    );
  });

  const BookingSummary = observer(({ isDisableTap, orderSnapshot }) => {
    const navigate = useNavigate();
    const popupRef = useRef();
    const [serviceProviders, setServiceProviders] = useState([]);
    const [totalServices, setTotalServices] = useState([]);
    const [isVerticalLayout, setIsVerticalLayout] = useState(window.innerWidth < window.innerHeight * 1.5);
  
    // Use the snapshot if provided; otherwise fallback to globalState.orderInCartMap
    const orderMap = orderSnapshot || globalState.orderInCartMap;
  
    useEffect(() => {
      const fetchData = async () => {
        const serviceProviderQuery = query(collection(db, 'serviceProvider'), where('isActive', '==', true));
        const serviceQuery = query(collection(db, 'service'), where('isActive', '==', true));
  
        const providerSnapshot = await getDocs(serviceProviderQuery);
        const serviceSnapshot = await getDocs(serviceQuery);
  
        setServiceProviders(providerSnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
        setTotalServices(serviceSnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
      };
  
      fetchData();
      const handleResize = () => {
        setIsVerticalLayout(window.innerWidth < window.innerHeight);
      };
  
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, []);
  
    const calculateTotalPrice = () => {
      return Object.keys(orderMap).reduce((total, key) => {
        const service = totalServices.find((s) => s.id === key);
        if (service) {
          return total + service.priceStartsFrom * orderMap[key];
        }
        return total;
      }, 0);
    };
  
    return (
      <div
        style={{
          backgroundColor: 'white',
          padding: '16px',
          borderRadius: '8px',
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
          flex: 1,
        }}
      >
       <h2 style={{
          fontWeight: 'bold',}}>Booking summary</h2>

        {Object.keys(orderMap).length > 0 && serviceProviders.length > 0 ? (
          // Wrap summary details in a container whose pointer events are disabled if isDisableTap is true
          <div style={{ pointerEvents: isDisableTap ? 'none' : 'auto' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '16px' }}>
              <span style={{ fontWeight: 'bold', flex: 4 }}>Items</span>
              {!isVerticalLayout && <span style={{ fontWeight: 'bold', flex: 1 }}>Quantity</span>}
              <span style={{ fontWeight: 'bold', flex: isVerticalLayout ? 2 : 1,
                  display: 'block', // or 'inline-block'
                  textAlign: 'right', }}>Price (MYR)</span>
            </div>
            <hr />
            {Object.keys(orderMap).map((serviceId) => {
              const service = totalServices.find((s) => s.id === serviceId);
              const provider = serviceProviders.find((p) => p.id === service?.serviceProviderId);
              if (!service) return null;
              return (
                <div key={serviceId} style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '16px'
                 }}>
                  <div style={{ flex: isVerticalLayout ? 2 : 4 }}>
                    <p style={{ margin: 0, fontWeight: 'bold' }}>{provider?.name}</p>
                    <p style={{ margin: 0 }}>{service.serviceTitle}</p>
                  </div>
                  <div style={{ alignItems: 'center', gap: '8px', flex: 1 
                  , marginLeft: isVerticalLayout ?   '0px':'0px' }}>
                  {!isDisableTap && (
                      <button
                        style={{ marginRight: '8px',
                          width: 18,           // fix width
                          height: 18,          // fix height
                          fontSize: 12,        // control the “+” size
                        }}
                        onClick={async () => {
                          const currentCount = orderMap[serviceId] || 0;
                          const newCount = Math.max(0, currentCount - 1);
                          if (newCount === 0) {
                            const result = await popupRef.current.show({
                              title: 'Remove this item?',
                              description: `${provider.name} - ${service.serviceTitle}`,
                            });
                            if (result) {
                              globalState.updateOrder(serviceId, -1);
                            }
                          } else {
                            globalState.updateOrder(serviceId, -1);
                          }
                        }}
                      >
                        −
                      </button>
                    )}
                    <span style={{marginLeft: isDisableTap ? '20px' : '0px'}}>{isDisableTap ?  `${orderMap[serviceId]}x`   : orderMap[serviceId]}</span>
                    {!isDisableTap && (
                        <button
                          onClick={() => globalState.updateOrder(serviceId, 1)}
                          style={{
                            marginLeft: 8,
                            width: 18,           // fix width
                            height: 18,          // fix height
                            fontSize: 12,        // control the “+” size
                          }}
                        >
                          +
                        </button>
                      )}


                  </div>
                  <span
                      style={{
                        flex: 1,
                        textAlign: isVerticalLayout ? 'left' : 'right',
                        display: 'flex',
                        justifyContent: 'flex-end',
                        alignItems: 'center',
                        marginRight: isVerticalLayout ? '0px' : '0px',
                        marginTop: isVerticalLayout ? '-20px' : '-20px', // extra spacing in vertical layout
                      }}
                    >
                      {(service.priceStartsFrom * orderMap[serviceId]).toLocaleString()}
                    </span>
                </div>
              );
            })}
            <hr />
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <span style={{ fontWeight: 'bold' }}>Total</span>
              <span style={{ fontWeight: 'bold', marginRight: isDisableTap ? '0px' : '0px' }}>
                {calculateTotalPrice().toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}
              </span>
            </div>
            <div style={{ height: '32px' }}></div>
          </div>
        ) : (
          <p>No items in cart.</p>
        )}
        {/* Explore Packages button placed outside the disabled container */}
        <button
          onClick={() => navigate('/adwav')}
          style={{
            width: '100%',
            padding: '8px',
            backgroundColor: '#EC3535',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            fontSize: '14px',
            fontWeight: 'bold',
            cursor: 'pointer',
          }}
        >
          Explore Packages
        </button>
        <PopupComponent ref={popupRef} />
      </div>
    );
  });
  
  
  

const ContactInfoForm = () => {
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [contactNumber, setContactNumber] = useState('');
  const [remarks, setRemarks] = useState(''); // New field for remarks
  const navigate = useNavigate();
  const { showLoading, hideLoading } = useLoading();

  const handleSubmit = async () => {
    
    if (Object.keys(globalState.orderInCartMap).length === 0) {
      alert('Your order cart is empty. Please add at least one item.');
      return;
    }

    if (!email || !name || !contactNumber) {
      alert('Please enter your email, name and contact number');
      return;
    }

    // Validate email format
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      alert('Please enter a valid email address');
      return;
    }

    // Validate that contact number contains only digits
    const contactRegex = /^0\d{9,}$/;
    if (!contactRegex.test(contactNumber)) {
      alert('Please enter a valid contact number');
      return;
    }
    // Simulating fetching services from Firestore
    const fetchServices = async () => {
      const serviceQuery = query(collection(db, 'service'), where('isActive', '==', true));
      const serviceSnapshot = await getDocs(serviceQuery);
      return serviceSnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
    };

    showLoading();

    try {
      const totalServices = await fetchServices();
      const snapshot = Object.keys(globalState.orderInCartMap)
        .map((key) => {
          const service = totalServices.find((s) => s.id === key);
          if (service) {
            return {
              ...service,
              orderQuantity: globalState.orderInCartMap[key],
            };
          }
          return null;
        })
        .filter(Boolean);

      // Pass the remarks field to the API
      const isSuccess = await ApiService.saveOrder({
        name,
        email,
        contactNumber,
        remarks, // Added remarks field here
        snapshot,
      });

      hideLoading(); // Stop loading spinner

      if (isSuccess) {
        logFirebaseEvent('orderCart', { name: name, email: email, contactNumber: contactNumber });
        navigate('/adwav/confirm'); // Navigate to booking confirmation page
      } else {
        alert('Failed to confirm booking');
      }
    } catch (error) {
      console.error('Error during submission:', error);
      alert('An error occurred. Please try again.');
      hideLoading(); // Stop loading spinner
    }
  };

  return (
    <div
      style={{
        backgroundColor: 'white',
        padding: '16px',
        borderRadius: '8px',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        flex: 1,
      }}
    >
      <h2 style={{ padding: '0', marginBottom: '0',
          fontWeight: 'bold', }}>Contact Info</h2>
      <span
        style={{
          fontSize: '12px',
          color: 'black',
          marginBottom: '16px',
          display: 'block',
        }}
      >
        We’ll be in touch within 1 working day. If you have any questions, feel free to email us at ads@newswav.com
      </span>
      <input
        type="email"
        placeholder="Your Email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        style={{
          width: '100%',
          marginBottom: '16px',
          padding: '8px',
          border: '1px solid #CCC',
          borderRadius: '8px',
          fontSize: '14px',
        }}
      />
      <input
        type="text"
        placeholder="Your Name"
        value={name}
        onChange={(e) => setName(e.target.value)}
        style={{
          width: '100%',
          marginBottom: '16px',
          padding: '8px',
          border: '1px solid #CCC',
          borderRadius: '8px',
          fontSize: '14px',
        }}
      />
      <input
        type="tel"
        placeholder="Your Contact Number"
        value={contactNumber}
        onChange={(e) => setContactNumber(e.target.value)}
        style={{
          width: '100%',
          marginBottom: '16px',
          padding: '8px',
          border: '1px solid #CCC',
          borderRadius: '8px',
          fontSize: '14px',
        }}
      />
      {/* New Remarks Field */}
      <textarea
        placeholder="Remarks (Optional)"
        value={remarks}
        onChange={(e) => setRemarks(e.target.value)}
        style={{
          width: '100%',
          marginBottom: '16px',
          padding: '8px',
          border: '1px solid #CCC',
          borderRadius: '8px',
          fontSize: '14px',
          resize: 'vertical',
        }}
      />
      <button
        onClick={handleSubmit}
        style={{
          width: '100%',
          padding: '8px',
          backgroundColor: '#EC3535',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          fontSize: '14px',
          fontWeight: 'bold',
          cursor: 'pointer',
        }}
      >
        Submit
      </button>
    </div>
  );
};


export { BookingSummary };
export default BookingScreen;
